import { array, boolean, mixed, number, object, string } from 'yup'

import { COMPETITIONS } from '@/components/forms/LicenseForm/constants'
import { UseCompetitionsType } from '@/constants/licenses'
import { isMsfpLicense } from '@/utils/licenseUtils'

export const DDE_licenseFormValidation = object().shape({
  sportLicenseProperty: object({
    label: string().required('Label is required'),
    value: string().required('Value is required')
  }).required('Sport license property is required'),
  useAllCompetitions: string().required('Competition select type is required'),
  competitions: array()
    .of(string().required('Competition ID is required'))
    .test('competitions-required', 'Competitions are required', function (value) {
      const { sportLicenseProperty, useAllCompetitions } = this.parent

      if (
        isMsfpLicense(sportLicenseProperty?.value.toString()) &&
        useAllCompetitions !== COMPETITIONS.SELECT_ALL
      ) {
        return value && value.length > 0
      }

      return true
    }),
  licensePeriods: array()
    .of(
      object({
        endDate: string().required('End date is required'),
        id: number().nullable(),
        numOfBookedEvents: number(),
        numOfConsumedEvents: number(),
        numOfEvents: number(),
        startDate: string().required('Start date is required'),
        subscription: object().shape({
          competitionIds: array().of(string()),
          type: mixed<UseCompetitionsType>().optional()
        }),
        unlimited: boolean()
      })
    )
    .required()
    .min(1, 'License periods are required')
})

export const licenseFormValidation = {
  DDE: DDE_licenseFormValidation
}
